import Vue from 'vue'
import App from './App'
import router from './router'
import VueHead from 'vue-head'
import VueAnalytics from 'vue-analytics'

import Product from './services/product'

Vue.config.productionTip = false
Vue.use(VueHead)

Vue.use(VueAnalytics, {
    id: 'UA-107886446-1',
    router
})

// import * as VueGoogleMaps from 'vue2-google-maps'
// Vue.use(VueGoogleMaps, {
//     load: {
//         key: 'AIzaSyBu4SUL6F5UN2_qpV5peYs54b0MR-1cmHw'
//     }
// })

const baseUrl = 'http://api.bimbi.bg/api'

Product.settings(`${baseUrl}/settings`)
    .then(res => {
        new Vue({
            el: '#app',
            router,
            template: '<App/>',
            data: {
                settings: res.data,
                baseUrl: baseUrl
            },
            components: { App }
        })
    })
    .catch(err => console.log(err))



// WEBPACK FOOTER //
// ./src/main.js